import { ISaveTaskOrder, ITaskSimple, ITaskSimpleUpdate } from '../../resource/task-simple/task-simple.types';
import {
  ICopyTask,
  IMoveTask,
  IAddAttachmentForm,
  ITask,
  ITaskCreate,
  ITaskSearchParams,
} from '../../resource/task/task.types';
import { IUser } from '../../resource/user/user.types';
import { IApiRequestConfig } from '../api.types';

export const searchTasksApi = (params?: ITaskSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'searchTasks',
  uri: 'json',
  action: 'tasks',
  method: 'get',
  params: {
    ...params,
  },
  v2: true,
});

export const getMyTasksApi = (params?: ITaskSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMyTasks',
  uri: 'json',
  action: 'getTasksByMember',
  method: 'get',
  params: {
    ...params,
  },
});
export const getSharedTaskApi = (id: ITaskSimple['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getSharedTaskApi',
  uri: 'json',
  action: 'getSharedTask',
  method: 'get',
  params: {
    id,
  },
});

export const createTaskApi = (task: ITaskCreate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createTaskApi',
  uri: 'json',
  action: 'saveTask',
  method: 'post',
  data: { ...task, watchers: [] },
});

export const updateTaskApi = (taskId: ITask['id'], task: ITaskSimpleUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateTaskApi',
  uri: 'json',
  action: `tasks/${taskId}`,
  method: 'patch',
  data: {
    ...task,
  },
  v2: true,
});

export const deleteTaskApi = (taskId: ITask['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteTaskApi',
  uri: 'json',
  action: 'deleteTask',
  method: 'delete',
  params: {
    id: taskId,
  },
});

export const moveTaskApi = (data: IMoveTask): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'moveTask',
  uri: 'json',
  action: 'moveTask',
  method: 'post',
  data: data,
});

export const copyTaskApi = (data: ICopyTask): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'copyTask',
  uri: 'json',
  action: 'copyTask',
  method: 'post',
  data: data,
});

export const updateTaskOrderApi = (taskTypeId: string, data: ISaveTaskOrder): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateTaskOrder',
  uri: 'json',
  action: `task-types/${taskTypeId}/update-tasks-order`,
  method: 'patch',
  data: data,
  v2: true,
});

export const getTaskWatchersApi = (taskId: ITask['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getWatchers',
  action: `tasks/${taskId}/watchers`,
  method: 'get',
  v2: true,
});
export const addTaskWatcherApi = (taskId: ITask['id'], userIds: IUser['id'][]): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'addWatcher',
  uri: 'json',
  action: `tasks/${taskId}/watchers`,
  method: 'post',
  data: {
    userIds,
  },
  v2: true,
});
export const removeTaskWatcherApi = (taskId: ITask['id'], userIds: IUser['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteWatcher',
  uri: 'json',
  action: `tasks/${taskId}/watchers`,
  method: 'delete',
  data: {
    userIds,
  },
  v2: true,
});
export const addTaskAttachmentApi = (taskId: ITask['id'], data: IAddAttachmentForm): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'addTaskAttachment',
  uri: 'json',
  action: `tasks/${taskId}/attachments`,
  method: 'post',
  data,
  v2: true,
});
